export default "__VITE_ASSET__9Zm7Orvk__"